import {createRouter, createWebHistory} from 'vue-router'
import {userAuthenticate} from "@/functions/userAuthenticate";
import store from "@/store";

const routes = [
    {
        path: '/',
        component: () => import('../views/layouts/AuthLayout.vue'),
        children: [
            { path: '', name: 'Landing', component: () => import('../views/Landing.vue') },
            {
                path: 'login',
                name: 'LoginView',
                redirect: '/login/request-otp',
                component: () => import('../views/LoginView.vue'),
                children: [
                    { path: 'request-otp', name: 'RequestOtp', component: () => import('../views/loginViews/RequestOtp.vue') },
                    { path: 'submit-otp', name: 'SubmitOtp', component: () => import('../views/loginViews/SubmitOtp.vue') },
                    { path: 'select-package', name: 'SelectPackage', component: () => import('../views/loginViews/SelectPackage.vue') },
                    { path: 'subscribe-confirmation', name: 'SubscribeConfirmation', component: () => import('../views/loginViews/SubscribeConfirmation.vue') },
                    { path: 'subscribe-success', name: 'SubscribeSuccess', component: () => import('../views/loginViews/SubscribeSuccess.vue') },
                    { path: 'create-username', name: 'CreateUsername', component: () => import('../views/loginViews/CreateUsername.vue') },
                    { path: 'how-to-play', name: 'HowToPlay', component: () => import('../views/loginViews/HowToPlay.vue') }
                ]
            }
        ]
    },
    {
        path: '/',
        component: () => import('../views/layouts/DefaultLayout.vue'),
        children: [
            { path: 'home', name: 'Home', component: () => import('../views/Home.vue') },
            { path: 'menu', name: 'MenuView', component: () => import('../views/MenuView.vue') },
            { path: 'profile', name: 'Profile', component: () => import('../views/menuViews/Profile.vue') },
            { path: 'prizes', name: 'Prizes', component: () => import('../views/menuViews/UserWinnings.vue') },
            { path: 'claim-prizes', name: 'ClaimPrizes', component: () => import('../views/menuViews/ClaimPrizes.vue') },
            { path: 'how-it-works', name: 'HowItWorksView', component: () => import('../views/menuViews/HowItWorksView.vue') },
            { path: 'terms-conditions', alias: '/terms-and-conditions', name: 'TermsAndConditions', component: () => import('../views/menuViews/TermsAndConditions.vue') },
            { path: 'referral', name: 'Referral', component: () => import('../views/menuViews/Referral.vue') },

            { path: 'more-plays', name: 'UpsellView', component: () => import('../views/UpsellView.vue') },
            { path: 'vip-subscription', name: 'VipSubscription', component: () => import('../views/VipSubscription.vue') },
            { path: 'subscribe/:selectedCategory/:serviceName/:subId/:toneId/:confirmOrPlay', name: 'SubscriptionView', component: () => import('../views/SubscriptionView.vue') },

            { path: 'lifestyle', name: 'LifestyleServices', component: () => import('../views/LifestyleServices.vue') },

            { path: 'upsell/service', name: 'ServiceUpsell', component: () => import('../views/upsellViews/ServiceUpsell.vue') },
            { path: 'upsell/service/confirm', name: 'ServiceUpsellConfirm', component: () => import('../views/upsellViews/ServiceUpsellConfirm.vue') },
            { path: 'upsell/confirmation', name: 'GetMorePlaysConfirmation', component: () => import('../views/upsellViews/GetMorePlaysConfirmation.vue') },
            { path: 'upsell/spend-stars', name: 'SpendStars', component: () => import('../views/upsellViews/SpendStars.vue') },

            { path: 'crate/standard/:id', name: 'OpenStandardCrate', component: () => import('../views/crateViews/OpenStandardCrate.vue') },
            { path: 'crate/revealed', name: 'CrateRevealed', component: () => import('../views/crateViews/CrateRevealed.vue') },

            { path: 'streak/:day', name: 'StreakDay', component: () => import('../views/streakViews/StreakDay.vue') },

            { path: 'game/loading', name: 'GameLoading', component: () => import('../views/gameViews/GameLoading.vue') },
            { path: 'game/tropic-take-off', name: 'TropicTakeOff', component: () => import('../views/gameViews/TropicTakeOff.vue') },
            { path: 'game/result/:outcome', name: 'GameOver', component: () => import('../views/gameViews/GameOver.vue') }
        ]
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        window.scrollTo(0, 0);
    }
})

const CROSS_SELL_ROUTES = new Set(['ServiceUpsell', 'ServiceUpsellConfirm']);

router.beforeEach(async (to, from, next) => {
    if (store.state.myBundle && CROSS_SELL_ROUTES.has(to.name)) return next({name: 'Home'});
    await userAuthenticate(to, from, next);
})

export default router
